import React, { useState } from 'react';
import CardGridSmart from "../../components/Card/CardGridSmart";
import img from "../../assets/images/logo192.png";
import Routing from "../../services/routing";
import DateService from "../../services/DateService";

const CardGridTestPage = props => {
    const handleRatingChange = (seanceId, newRating) => {
    };

    const seances = [{
        "id": 5008,
        "type": 18,
        "titre": "Sophrologie",
        "date": "2024-02-02T08:05:06+01:00",
        "heure": "2015-11-21T00:00:00+01:00",
        "participantsMax": 6,
        "coach": {
            "prenom": "Daniel",
            "nom": "Daniel"
        },
        "placesRestantes": 6,
        "image": "api/images/sophrologie.jpg",
        "userRegistered": true,
        "userRegisteredLabel": "Inscrit",
        "userNonRegisteredLabel": "S'inscrire",
        "startDate": "2024-02-28T00:00:00+00:00",
        "endDate": "2024-02-28T05:00:00+00:00",
        "duree": "5h",
        "enListeDattente": false,
        "rate": 55
    }, {
        "id": 5005,
        "type": 18,
        "titre": "Test piscine",
        "date": "2024-02-25T08:05:06+01:00",
        "heure": "2015-11-21T00:00:00+01:00",
        "participantsMax": 6,
        "coach": {
            "prenom": "Daniel",
            "nom": "Daniel"
        },
        "placesRestantes": 6,
        "image": "api/images/sophrologie.jpg",
        "userRegistered": false,
        "userRegisteredLabel": "Inscrit",
        "userNonRegisteredLabel": "S'inscrire",
        "startDate": "2024-02-28T00:00:00+00:00",
        "endDate": "2024-02-28T05:00:00+00:00",
        "duree": "5h",
        "enListeDattente": false,
        "rate": 55
    }, {
        "id": 54,
        "type": 18,
        "titre": "Test parachute",
        "date": "2024-02-25T08:05:06+01:00",
        "heure": "2015-11-21T00:00:00+01:00",
        "participantsMax": 6,
        "coach": {
            "prenom": "Daniel",
            "nom": "Daniel"
        },
        "placesRestantes": 6,
        "image": "api/images/sophrologie.jpg",
        "userRegistered": true,
        "userRegisteredLabel": "Inscrit",
        "userNonRegisteredLabel": "S'inscrire",
        "startDate": "2024-02-28T00:00:00+00:00",
        "endDate": "2024-02-28T05:00:00+00:00",
        "duree": "5h",
        "enListeDattente": false,
        "rate": 55
    }, {
        "id": 500,
        "type": 18,
        "titre": "Test file dattetnet",
        "date": "2024-02-25T08:05:06+01:00",
        "heure": "2015-11-21T00:00:00+01:00",
        "participantsMax": 6,
        "coach": {
            "prenom": "Daniel",
            "nom": "Daniel"
        },
        "placesRestantes": 6,
        "image": "api/images/sophrologie.jpg",
        "userRegistered": true,
        "userRegisteredLabel": "Inscrit",
        "userNonRegisteredLabel": "S'inscrire",
        "startDate": "2024-02-28T00:00:00+00:00",
        "endDate": "2024-02-28T05:00:00+00:00",
        "duree": "5h",
        "enListeDattente": true,
        "rate": 55
    }];

    let newCardsData = seances.map(seance => ({
        id: seance.id,
        lien: Routing.generate({route: Routing.routes.seance, params: { id: seance.id }}),
        image: img,
        titre: seance.titre,
        userRegistered: seance.userRegistered,
        userRegisteredLabel: seance.userRegisteredLabel ?? "",
        userNonRegisteredLabel: seance.userNonRegisteredLabel ?? "",
        date: seance.date,
        rows: [
            "Date - " + DateService.formatDateWithoutTime(seance.date),
            "Places disponibles : "+seance.placesRestantes
        ],
        waiting: seance.enListeDattente,
        ratingColor: "transparent",
        ratingFilledColor: "#fff",
        ratingValue: seance.rate ? seance.rate.value :  0,
        onChange: (newRating) => handleRatingChange(seance.id, newRating)
    }));

    return (
        <div className="content">
            {newCardsData.length > 0 && <CardGridSmart cards={newCardsData} />}

        </div>
    );
};

export default CardGridTestPage;
